import {TariffFlagKey} from 'entities/tariff';

export type TariffBadgeVariant = 'default' | 'recommended' | 'archive';

export interface ITariffBadge {
    key: TariffFlagKey,
    label: string,
    variant: TariffBadgeVariant,
}

export const TARIFF_BADGES: ITariffBadge[] = [
    {key: 'is_default', label: 'По умолчанию', variant: 'default'},
    {key: 'is_recommended', label: 'Рекомендуемый', variant: 'recommended'},
    {key: 'is_archive', label: 'Архив', variant: 'archive'},
];
